module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="power-slider"><label for="power-alert-enabled">{{ tc(\'ControlHomeAlerts\', \'Power alert:\') }}</label><div class="input" id="power-alert-enabled"><defa-radio-strip v-model="powerSwitchValue" :options="powerSwitchOptions" :class="{ errorState: model.mainsAlarmMask === null}" v-on:input="save($event, \'mainsAlarmMask\')"></div><dl v-show="model.modelError || model.mainsAlarmMaskError"><dd><p class="error">ERROR! {{ model.modelError || model.mainsAlarmMaskError }}</p></dd></dl></div>';
}
return __p;
};
